// extracted by mini-css-extract-plugin
export default {"autoCompleteStyles":"GlobalAutoComplate_autoCompleteStyles__3VG+d","chip":"GlobalAutoComplate_chip__pvl1O"};